
export class ApplyForm {
	id?: number;

	name: string;
	phone: string;
	date: string;
	time: string;
  location: any;
  type: string;

	agree?: boolean;
	author?: string;
}

export class GuestItem {

}


// WEBPACK FOOTER //
// ./src/app/service/guest/guest.ts